import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, SimpleChange, OnChanges } from '@angular/core';

@Component({
  selector: 'luci-input',
  templateUrl: './luci-input.component.html',
  styleUrls: ['./luci-input.component.scss']
})
export class LuciInputComponent implements OnInit, OnChanges {

  private defaultInvalidMsg = 'The value in this field is invalid';
  private defaultMandatoryMsg = 'This field is mandatory';
  @Input() inputModel: any = '';
  @Output() inputModelChange = new EventEmitter<any>();
  @Output() onvalidate = new EventEmitter<any>();
  @Input() forceValidation = false;
  @Input() label = '';
  @Input() error = false;
  @Input() isReadOnly = false;
  @Input() errorMsg = '';
  @Input() numberOnlyMsg = this.defaultInvalidMsg;
  @Input() numberOnly = false;
  @Input() allowDot = false;
  @Input() allowOnly: any[] = [];
  @Input() allowOnlyMsg = this.defaultInvalidMsg;
  @Input() allowRegEx = '';
  @Input() maxValue: number;
  @Input() maxValueMsg = this.defaultInvalidMsg;
  @Input() minValue: number;
  @Input() minValueMsg = this.defaultInvalidMsg;
  @Input() isMandatory = false;
  @Input() isMandatoryIcon = false;
  @Input() mandatoryMsg = this.defaultMandatoryMsg;
  @Input() textarea = false;
  @Input() id = '';
  @Input() isEmail = false;
  @Input() rows = 4;
  @Input() cols = 80;
  @Input() isEmailMsg = this.defaultInvalidMsg;
  @Input() isDisabled = false;
  @Input() isHelptext = false;
  @Input() titleHelptext = '';
  @Input() placeholder = '';
  @Input() name = 'textBox';
  @Output() enterStroke = new EventEmitter<any>();
  @Output() focusOut = new EventEmitter<any>();

  showErrorMsg = false;
  showNumberOnlyMsg = false;
  showAallowOnlyMsg = false;
  showMaxValueMsg = false;
  showMinValueMsg = false;
  showMandatoryMsg = false;
  showEmailMsg = false;
  emitBlurEvent = true;

  constructor() { }

  ngOnInit() {
    if (this.isMandatory) {
      if (this.inputModel === '') {
        this.onvalidate.emit({ id: this.id, status: false });
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const forceValidation: SimpleChange = changes.forceValidation;
    const inputModel: SimpleChange = changes.inputModel;
    if (forceValidation && forceValidation.currentValue) {
      this.validate();
    } else if (inputModel && inputModel.currentValue) {
      this.validate();
    }
  }

  emitFieldEvents(event: any) {
    const eventType = (event.type === 'blur') ? 'blur' : (event.type === 'keydown' && event.key === 'Enter') ? 'enter' : '' ;
    if (eventType === 'blur' && this.emitBlurEvent) {
      this.emitBlurEvent = false;
      this.focusOut.emit(event.target.value);
    } else if (eventType === 'enter') {
      this.emitBlurEvent = false;
      this.enterStroke.emit(event.target.value);
    }
  }

  private unsetAllErrors() {
    this.error = false;
    this.showErrorMsg = false;
    this.showNumberOnlyMsg = false;
    this.showAallowOnlyMsg = false;
    this.showMaxValueMsg = false;
    this.showMinValueMsg = false;
    this.showMandatoryMsg = false;
    this.showEmailMsg = false;
  }

  keyDownHandler(event: any) {
    if (event.which === 32) {
      if (this.numberOnly) {
        event.preventDefault();
      }
    }
  }
  validateRegEx(event: any) {
    if (this.allowRegEx) {
      const pattern = new RegExp(this.allowRegEx); // /^[0-9/,\s]*$/g;
      if (!pattern.test(event.target.value)) {
        const str = event.target.value;
        event.target.value = str.slice(0, -1);
      }
    }
  }

  validate() {
    this.emitBlurEvent = true;
    const numberRegex = this.allowDot ? /^[0-9.]+$/ : /^[0-9]+$/;
    const numberRegexValid = numberRegex.test(this.inputModel);
    const emailRegex = /^[a-zA-Z0-9-.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const emailRegexValid = emailRegex.test(this.inputModel);

    if (this.numberOnly) {
      const newStr = this.inputModel.toString().split(' ').join('');
      this.inputModel = newStr;
    }

    this.unsetAllErrors();
    if (!this.textarea) {
      this.inputModel = this.inputModel.replace(/\s\s+/g, ' ');
    }

    if (this.isMandatory && this.inputModel === '' && this.inputModel === ' ') {
      this.error = true;
      this.showMandatoryMsg = true;
    } else if (this.numberOnly && !numberRegexValid) {
      this.error = true;
      this.showNumberOnlyMsg = true;

    } else if (this.numberOnly && this.maxValue || this.numberOnly && this.minValue) {
      const num = Number(this.inputModel);
      if (this.maxValue < num) {
        this.error = true;
        this.showMaxValueMsg = true;

      } else if (this.minValue > num) {
        this.error = true;
        this.showMinValueMsg = true;

      }
    } else if (this.isEmail && !emailRegexValid && this.inputModel !== '') {
      this.error = true;
      this.showEmailMsg = true;
    } else if (this.allowOnly.length > 0 && this.inputModel !== '') {
      const splitInput = this.inputModel.toString().split('');
      const checkExistInAllowOnly = splitInput.map(val => {
        const exist = this.allowOnly.includes(val);
        return exist;
      });
      const checkExist = checkExistInAllowOnly.includes(false);
      if (checkExist) {
        this.error = true;
        this.showAallowOnlyMsg = true;
      }
    } else if (this.inputModel.trim() === '' && this.forceValidation) {
      this.error = true;
    }

    this.onvalidate.emit({ id: this.id, status: !this.error });
  }
}
